import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import TopBar from './TopBar';
import BottomTabs from './BottomTabs';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import AddToHomeScreen from '@/components/common/AddToHomeScreen';

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const isHome = location.pathname === '/';
  return (
    <div className="min-h-screen bg-[#0a0e1a]">
      <TopBar />
      <BottomTabs />
      <AddToHomeScreen active={isHome} />

      <main
        role="main"
        className="pt-14 pb-16"
      >
        <div className="px-3 py-3 sm:px-4 md:p-6">
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
      </main>
    </div>
  );
}
